export default __webpack_public_path__ + "static/media/pivotal_tracker.1085738c.svg";